import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllDocs, layerSelector } from '../../store/feature/layerSlice';
import { get_dynamic_styles } from '../../constant/DynamicStyles';
import { dynamic_text_convert } from '../../utils/dynamicTextConvert';
import Link from 'next/link';
import { useRouter } from 'next/router';

const DocsList = ({ data, styles }) => {
  const dispatch = useDispatch();
  const { all_docs } = useSelector(layerSelector);
  const router = useRouter();

  const current_doc = router?.query?.slug;

  useEffect(() => {
    const prams = {
      page: 1,
      type: 'docs',
      per_page: data?.per_page ?? 100,
      minified: 1,
    };
    if (data?.per_page) {
      prams.per_page = data?.per_page;
    }
    if (data?.minified) {
      prams.minified = data?.minified;
    }
    if (data?.category_id) {
      prams.category_id = data?.category_id;
    }

    dispatch(
      getAllDocs({
        prams,
      })
    );
  }, []);

  return (
    <div style={get_dynamic_styles(styles?.main_styles)}>
      <div
        style={{
          display: styles?.box_styles?.display,
          ...get_dynamic_styles(styles?.box_styles),
        }}
      >
        {all_docs?.map((doc) => {
          return (
            <Link key={doc.id} href={`/o/${doc.slug}`}>
              <div
                className="cursor-pointer"
                style={
                  current_doc === doc?.slug
                    ? get_dynamic_styles(styles?.selected_menu_item)
                    : get_dynamic_styles(styles?.menu_item)
                }
              >
                {doc.title}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default DocsList;
